import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { styled } from "@mui/system";
import { BaseInputField } from '../style/textfield'


const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": { maxWidth: "90%" },
}));


export const InputDialog = ({
  open,
  onClose,
  title,
  message,
  onConfirm,
  confirmText,
  cancelText,
  errors,
  label,
  registerProps,
}) => {
  return (
    <StyledDialog open={open} onClose={onClose} aria-labelledby="custom-dialog-title" >
      {title && <DialogTitle id="custom-dialog-title">{title}</DialogTitle>}
      <DialogContent sx={{py: 2}}>
        <DialogContentText style={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
        {errors.note && (
          <Typography color="error" sx={{ fontSize: '0.9rem' }}>
            {errors.note?.message}
          </Typography>
        )}
        <BaseInputField
          label={label}
          multiline
          maxRows={15}
          sx={{
            mt: '5px',
            width: { xs: '75%', sm: '70%', md: '70%' },
            maxWidth: '300px',
            '& .MuiInputBase-root': {
              minHeight: '100px',
              alignItems: 'flex-start',
            },
          }}
          {...registerProps}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};